import { useQuery, useMutation } from '@apollo/client';
import {
  GET_OATT_NSP_CORE_INFO_LIST,
  UPDATE_OATT_NSP_CORE_INFO,
} from '@graphql/oattNspCoreInfo.gql';
import type { OattNspCoreInfo, UpdateOattNspCoreInfoInput } from '@custom-types/oattNspCoreInfo';

export function useOattNspCoreInfoList() {
  const { data, loading, error, refetch } = useQuery<{ oattNspCoreInfoList: OattNspCoreInfo[] }>(
    GET_OATT_NSP_CORE_INFO_LIST
  );

  return {
    data: data?.oattNspCoreInfoList ?? [],
    loading,
    error,
    refetch,
  };
}

export function useUpdateOattNspCoreInfo() {
  const [updateMutation, { loading: updating }] = useMutation(UPDATE_OATT_NSP_CORE_INFO);

  const handleUpdate = async (oattNspCoreInfoId: number, input: UpdateOattNspCoreInfoInput) => {
    try {
      const result = await updateMutation({ variables: { oattNspCoreInfoId, input } });
      const payload = result.data?.updateOattNspCoreInfo;
      return { success: payload?.success ?? false, error: payload?.message };
    } catch (err) {
      return { success: false, error: err instanceof Error ? err.message : 'Update failed' };
    }
  };

  return { handleUpdate, updating };
}
